import { render } from "./CreateTaskItemDialog.vue?vue&type=template&id=71c55c0f"
import script from "./CreateTaskItemDialog.vue?vue&type=script&lang=js"
export * from "./CreateTaskItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__